import { apiService, createRequestHeadersConfig } from 'shared/api'

import { CustomerTypes } from './types'

const api = apiService()

export interface UpdateCustomerValuesPayload {
  firstName?: string
  lastName?: string
  dateOfBirth?: string
  phoneNumber?: string
  email?: string
  currentPassword?: string
  newPassword?: string
  newPasswordConfirmation?: string
  marketingConsentsGranted?: boolean
  smsConsentsGranted?: boolean
  isNewsletterSubscriber?: boolean
}

interface UpdateCustomerDetailsPayload {
  token?: string
  values: UpdateCustomerValuesPayload
}

export interface UpdateCustomerDetailsResponse {
  data: {
    data: CustomerTypes
  }
}

export const updateCustomerDetails = (
  payload: UpdateCustomerDetailsPayload
): Promise<UpdateCustomerDetailsResponse> => {
  const { values, token } = payload

  return api.patch(`/me/update-account`, values, createRequestHeadersConfig(token))
}

interface RemoveCustomerAccountPayload {
  token?: string
  password: string
}

export const removeCustomerAccount = (payload: RemoveCustomerAccountPayload) => {
  const { password, token } = payload

  return api.post(
    `/me/anonymize-account`,
    { password },
    createRequestHeadersConfig(token)
  )
}

export interface GetCustomerResponse {
  data: {
    data: CustomerTypes
  }
}

export const getCustomer = ({ token }: { token: string }): Promise<GetCustomerResponse> => api.get('/me', createRequestHeadersConfig(token))
